import CTASection from "../components/CTASection";
import RiskWarning from "../components/RiskWarning";
import { CheckCircle } from "lucide-react";

export default function Services() {
  const services = [
    {
      title: "Equity Mutual Funds",
      description: "Distribution of equity-oriented mutual fund schemes across market capitalizations."
    },
    {
      title: "Debt Mutual Funds",
      description: "Access to debt and fixed income mutual fund products with varying duration profiles."
    },
    {
      title: "Hybrid Funds",
      description: "Balanced fund distribution combining equity and debt allocations."
    },
    {
      title: "Index Funds & ETFs",
      description: "Passive investment product distribution tracking various market indices."
    },
    {
      title: "Tax Saving Funds",
      description: "ELSS and other tax-efficient mutual fund product distribution."
    },
    {
      title: "Liquid Funds",
      description: "Short-term liquid fund distribution for treasury and cash management needs."
    }
  ];

  return (
    <div id="main-content" className="pt-20" data-testid="services-page">
      <section className="py-32 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-gray-100" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Mutual Fund Distribution Services
          </h1>
          <p className="text-lg text-gray-400 mb-12">
            We distribute a comprehensive range of mutual fund products to suit diverse investment objectives. 
            As an AMFI-registered distributor, we provide access to products from leading asset management companies.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            {services.map((service, index) => (
              <div key={index} className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg hover:border-[#d4af69] transition-all" data-testid={`service-card-${index}`}>
                <div className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-[#d4af69] flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="text-xl font-semibold mb-2 text-gray-100">{service.title}</h3>
                    <p className="text-gray-400 text-sm">{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg mb-8" data-testid="important-note">
            <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Important Information</h2>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="flex items-start gap-2">
                <span className="text-[#d4af69] mt-1">•</span>
                <span>All information provided is for educational purposes only and does not constitute investment advice.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#d4af69] mt-1">•</span>
                <span>Past performance is not indicative of future returns.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#d4af69] mt-1">•</span>
                <span>We are distributors only and do not provide advisory services unless separately registered.</span>
              </li>
            </ul>
          </div>

          <CTASection />

            <RiskWarning />
        </div>
      </section>
    </div>
  );
}